import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Login.module.css';
import { IoPersonCircleOutline } from "react-icons/io5";
import { useTheme } from "../ThemeContext/ThemeContext";
import { useNavVisibility } from '../NavVisibilityContext/NavVisibilityContext';
import logo from '../../assets/logo.svg';
import logoLight from '../../assets/logo-light.svg';
import authApi from "../../utils/auth.api";

const ForgotPassword = ({ handleShowHeader, handleShowSettingsHeader }) => {
    const [clientId, setClientId] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const { isDarkMode } = useTheme();
    const { setIsNavVisible } = useNavVisibility();
    const logoSrc = isDarkMode ? logoLight : logo;

    useEffect(() => {
        handleShowHeader(false);
        handleShowSettingsHeader(false);
        setIsNavVisible(false);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await authApi.forgotPassword(clientId);

            if (response.success) {
                setSuccess(response.message);
                setError('');
                setClientId('');
            } else {
                setError(response.message);
                setSuccess('');
            }
        } catch (err) {
            setError(err.message);
            setSuccess('');
        }
    };

    return (
        <div className={styles.container}>
            <Link to={"https://mckinneytaxservices.com"} className={styles.logoWrap}>
                <h2 className={styles.logoText}>McKinney Tax Services</h2>
                <div className={styles.logoContainer}>
                    <img src={logoSrc} alt="Logo" className={styles.logo}/>
                </div>
            </Link>

            <div className={styles.formContainer}>
                <div className={styles.formCard}>
                    <h2 className={styles.title}>Forgot Password</h2>
                    <form onSubmit={handleSubmit} className={styles.form}>
                        <div className={styles.inputWrap}>
                            <div className={styles.inputGroup}>
                                <div className={styles.inputWrapper}>
                                    <IoPersonCircleOutline className={styles.icon}/>
                                    <input
                                        className={styles.input}
                                        type="text"
                                        value={clientId}
                                        placeholder="Enter Your Client Id"
                                        onChange={(e) => setClientId(e.target.value)}
                                        required
                                    />
                                </div>
                            </div>
                            {error && (
                                <div className="text-red-700 font-bold text-sm my-2">
                                    {error}
                                </div>
                            )}
                            {success && (
                                <div className="text-green-700 font-bold text-sm my-2">
                                    {success}
                                </div>
                            )}
                        </div>

                        <div className={styles.buttonGroup}>
                            <div className={styles.registerLink}>
                                <span>Remember your password? </span>
                                <br/>
                                <Link to="/login">Back to login</Link>
                            </div>
                            <button className={styles.submitButton} type="submit">
                                Send Reset Link
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
